import React, { useState } from 'react'
import { SplitButton } from 'components/ds'
import type { SplitButtonDropdownItem } from 'components/ds'
import { CreateNewProjectModal } from '../create-new-project-modal'
import { useNavigate } from 'react-router-dom'
import style from './new-brief-dropdown.module.css'
import mixpanel from '@disco/api/mixpanel'

export const NewBriefDropdown: React.FC = () => {
  const navigate = useNavigate()
  const [isProjectModalOpen, setIsProjectModalOpen] = useState(false)

  const handleNewBrief = () => {
    mixpanel.sendPureEvent('Brief created', {Context: 'Briefs', source: 'header'})
    navigate('/brief-editor/new')
  }

  const handleNewProject = () => {
    setIsProjectModalOpen(true)
  }

  const dropdownItems: SplitButtonDropdownItem[] = [
    {
      label: 'New project',
      onSelect: handleNewProject,
    },
  ]

  return (
    <div className={style.container}>
      <SplitButton
        caption="New Brief"
        size="1"
        variant="solid"
        onClick={handleNewBrief}
        dropdownItems={dropdownItems}
      />

      <CreateNewProjectModal
        isOpen={isProjectModalOpen}
        onClose={() => setIsProjectModalOpen(false)}
      />
    </div>
  )
}
